// CONSTANTS
export const CURRENCY = "₦";

// export const API_BASE_URL = "https://api.storbolt.io";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const categories = [
    "Cakes",
    "Pastries & Desserts",
    "Beverages",
    "Café Meals",
    "Vegan & Gluten-Free",
    "Gift & Party Packs",
    "Special Orders",
    "Custom Cakes",
    "Wedding Cakes",
    "Birthday Cakes",
    "Specialty Cakes",
    "Cupcakes & Muffins",
    "Tarts & Pies",
    "Waffles",
    "Ice Cream",
    "Brownies & Bars",
    "Cookies & Biscuits",
    "Coffee & Espresso",
    "Teas & Infusions",
    "Cold Drinks",
    "Smoothies",
    "Milk Shakes",
    "Juices",
    "Sweets",
    "Hot Chocolates",
    "Sandwiches & Wraps",
    "Bread",
    "Salads & Light Meals",
    "Quiches & Savory Pies",
    "Vegan Cakes & Desserts",
    "Gluten-Free Pastries",
    "Dairy-Free Drinks",
    "Cake Gift Boxes",
    "Party Platters",
    "Corporate Gift Sets",
    "Custom Cake Designs",
    "Personalized Treats",
    "Seasonal Specials (Holidays, Events)",
    "Water",
    "Others",
];
